/**
 *
 * FlashCardLanding
 *
 */

import { mapActions } from 'vuex';

export const GetCourseFlashCardListMixin = {
  name: 'GetCourseFlashCardListMixin',

  methods: {
    ...mapActions('FlashCard/FlashCardLanding', {
      ma_getCourseFlashCardList: 'getCourseFlashCardList',
    }),

    getCourseFlashCardList() {
      this.ma_getCourseFlashCardList(this.$route.params.courseId);
    },
  },

  created() {
    this.getCourseFlashCardList();
  },
};
